"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gainsightTrack = exports.initializeGainsightWithScript = exports.prepareGainsightData = void 0;
var prepareGainsightData = function (data) {
    if (!shouldUseGainsight) {
        return;
    }
    window.aptrinsic('identify', {
        id: data.email,
        fullName: data.fullName,
        role: data.role,
        locale: data.locale
    }, {
        id: data.account_name,
        name: data.customer_display_name,
        isPoc: data.is_poc,
        isPlgTenant: data.is_plg_tenant,
        isUniversity: data.is_university,
        isLean: data.is_lean_license,
        isInternal: data.is_internal,
        authType: data.auth_type,
        sfdcId: data.sf_account_id,
        parentGroupId: data.sf_account_id
    });
};
exports.prepareGainsightData = prepareGainsightData;
var scriptElement = "\n  (function (n, t, a, e, co) {\n    var i = \"aptrinsic\"; n[i] = n[i] || function () {\n      (n[i].q = n[i].q || []).push(arguments)\n    }, n[i].p = e; n[i].c = co;\n    var r = t.createElement(\"script\"); r.async = !0, r.src = a + \"?a=\" + e;\n    var c = t.getElementsByTagName(\"script\")[0]; c.parentNode.insertBefore(r, c)\n  })(window, document, \"https://web-sdk-eu.aptrinsic.com/api/aptrinsic.js\", \"AP-OUTCS1LUU47P-2\");\n";
var initializeGainsightWithScript = function () {
    if (!shouldUseGainsight) {
        return;
    }
    try {
        var gainsightScriptElement = document.querySelector('script#gainsight-script');
        if (!gainsightScriptElement) {
            gainsightScriptElement = document.createElement('script');
            gainsightScriptElement.classList.add('gainsight-script');
            document.head.appendChild(gainsightScriptElement);
        }
        gainsightScriptElement.innerHTML = scriptElement;
    }
    catch (e) {
        console.error('gainsight initialization failed');
    }
};
exports.initializeGainsightWithScript = initializeGainsightWithScript;
var gainsightTrack = function (eventName, properties) {
    if (!shouldUseGainsight) {
        return;
    }
    try {
        window.aptrinsic('track', eventName, properties);
    }
    catch (e) {
        console.error(e);
    }
};
exports.gainsightTrack = gainsightTrack;
var shouldUseGainsight = process.env.CB_USE_MIXPANEL == 'true';
